import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import axios from "axios";
import { UserProvider } from "./contexts/UserContext";
import "./styles/main.css";
import "antd/dist/antd.css";

//axios.defaults.baseURL = "http://localhost:6090/";
axios.defaults.baseURL = "https://www.computing.psu.ac.th/nattapong/memmify/";

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = token;
}

ReactDOM.render(
  // <React.StrictMode>
  <UserProvider>
    <App />
  </UserProvider>,
  // </React.StrictMode>,
  document.getElementById("root")
);
